import {REGEX} from '@/helpers'

export default {
    data() {
        return {
            error: ''
        }
    },
    computed: {
        validationRegEx() {
            switch (this.name) {
                case 'email':
                    return REGEX.EMAIL
                case 'job_type_id':
                    return REGEX.NUMBER_NOT_ZERO
                case 'message':
                    return REGEX.TEXT
                case 'phone':
                    return REGEX.PHONE
                default:
                    return REGEX.NAME
            }
        }
    },
    methods: {
        validateField(value) {
            if (this.required && !value) {
                return this.error = this.$t('errors.empty')
            }
            if (value && value !== '' && !this.validationRegEx.test(value)) {
                return this.error = this.$t('errors.pattern').replace('[FIELD]', this.label)
            }

            return this.error = ''
        },
        valueChange(event) {
            this.validateField(event.target.value)
            this.$emit('update:modelValue', {valid: this.error === '', value: event.target.value})
        }
    }
}